import groq from 'groq'
import { MediaObjectQuery } from '~/app/queries/molecules/MediaObjectQuery'

export const FaneModulQuery = groq`
  _type == 'FaneModul' => {
  ...,
    _type,
    _key,
    ${MediaObjectQuery},
    innerBlocks[] {...,},
  }
`
